import { Box, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import CustomModal from '../../CustomModal/CustomModal';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
}) => {
  return (
    <CustomModal handleClose={onClose} open={open}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: '312px',
            height: '201px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '22px', xl: '32px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                {'Delete Task?'}
              </Typography>
              <Typography variant='body2' color={zeplinColor.BasicBlack}>
                {'Are you sure you want to delete this task? This action cannot be undone.'}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <Box onClick={onClose} sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor: zeplinColor.Neutral1,
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                  }}
                  aria-role='button'
                  aria-disable={loading}
                >
                  <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                    Cancel
                  </Typography>
                </CustomCard>
              </Box>
              <Box onClick={onConfirm} sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor: zeplinColor.Error,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                  }}
                  aria-role='button'
                  aria-disable={loading}
                >
                  <Typography
                    variant='buttonMedium'
                    color={zeplinColor.Neutral1}
                    sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                  >
                    {loading ? 'Deleting' : 'Delete'}
                  </Typography>
                </CustomCard>
              </Box>
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};
